$sectionWidth: 320px;

:host {
  display: block;
  max-width: 100%;
}

.section {
  width: $sectionWidth;
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

gz-enum-list {
  &::part(listOptions) {
    border: 1px solid var(--chart-101-pressed-dividers);
    margin: 0 var(--spacer);
    border-radius: 4px;
    height: auto;
    min-height: 25px;
    max-height: 288px;
  }

  &::part(listGroup) {
    border: none;
  }
}

gz-enum-list {
  margin-left: -8px;
}

gz-text[class='empty-tags'] {
  display: flex;
  align-items: center;
  height: 32px;
  color: var(--chart-300-icon-buttons);
}

gz-selected-list {
  padding-top: calc(var(--spacer) * 2 - 4px);
}
